import { OrderType } from '@oolio-group/domain';

export enum OrbOrderStatus {
  PREPARING = 'Preparing',
  READY = 'Ready',
  ELAPSED = 'Elapsed',
}

export interface Order {
  /** Unique identifier for the order */
  id: string;
  /** Order number displayed to customers (e.g., "ORD-12345") */
  orderNumber: string;
  /** Customer's display name */
  customerName?: string;
  /** Customer identifier such as phone number or customer ID */
  customerIdentifier?: string;
  /** Current processing status of the order */
  status: OrbOrderStatus;
  /** Whether this order was placed online (vs in-venue POS/KIOSK) */
  isOnline?: boolean;
  /** Full order type object containing id and name */
  orderType: Pick<OrderType, 'id' | 'name'>;
  /** Name of the order type (e.g., "Pickup", "Dine In", "Delivery") */
  orderTypeName?: string;
  /** Name of the table for dine-in orders (e.g., "Table 5", "Counter 1") */
  tableName?: string;
  /** Numeric token identifier for order pickup */
  tokenNumber?: number;
  /** Name of the sales channel for online orders (e.g., "Uber Eats", "Online Store") */
  salesChannelName?: string;
  /** Timestamp when the order was created */
  createdAt: number;
  /** Timestamp when the order was last updated (e.g., status change) */
  updateTime: number;
}
